module.exports = __webpack_public_path__ + "img/GLOBAL_DT.f2c72fe1.png";